import {
  RETRIEVE_USERS,
  RETRIEVE_REPORTED_USERS,
  RETRIEVE_SINGALE_USER,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
  RESTORE_USER,
  UPDATE_USER_STATUS,
  ADD_USER_SUPERADMIN,
  RETRIEVE_USERS_Ad,
  ONLINEUSERS,
  ONLINEUSERSOBJ,
  NOONLINEUSERSOBJ,
  FETCH_KYC_LIST,
  FETCH_KYC_LIST_SUCCESS,
  FETCH_KYC_LIST_FAILURE,
  FETCH_USER_KYC_DETAILS,
  FETCH_USER_KYC_DETAILS_SUCCESS,
  FETCH_USER_KYC_DETAILS_FAILURE,
  UPDATE_MODULE,
} from "./types";

import UserService from "../../redux/services/user.service";

export const retrieveUsers = (param) => async (dispatch) => {
  try {
    const res = await UserService.getAll(param);
    dispatch({
      type: RETRIEVE_USERS,
      payload: {
        ...res.data.listUsers,
        totalActiveUsers: res.data.totalActiveUsers,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

export const retrieveReportedUsers = (param) => async (dispatch) => {
  try {
    const res = await UserService.getReported(param);
    dispatch({
      type: RETRIEVE_REPORTED_USERS,
      payload: res.data.listUsers,
    });
  } catch (err) {
    console.log(err);
  }
};

export const retrieveActiveList = (param, id) => async (dispatch) => {
  try {
    const res = await UserService.getActiveList(param, id);
    dispatch({
      type: RETRIEVE_USERS_Ad,
      payload: res.data.listAds,
    });
  } catch (err) {
    console.log(err);
  }
};

export const retrieveSingleUser = (id) => async (dispatch) => {
  try {
    const res = await UserService.get(id);
    dispatch({
      type: RETRIEVE_SINGALE_USER,
      payload: { user: res?.data?.userInfo },
    });
    return Promise.resolve(res?.data?.userInfo);
  } catch (err) {
    console.log(err);
  }
};

export const createUser = (data) => async (dispatch) => {
  try {
    const res = await UserService.create(data);

    dispatch({
      type: CREATE_USER,
      payload: res.data.userInfo,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateUser = (id, data) => async (dispatch) => {
  try {
    const res = await UserService.update(id, data);

    dispatch({
      type: UPDATE_USER,
      payload: res.data.userInfo,
    });

    const userObj = {
      firstName: res.data?.userInfo?.firstName,
      lastName: res.data?.userInfo?.lastName,
      email: res.data?.userInfo?.email,
      profileImage: res.data?.userInfo?.profileImage,
      publicId: res.data?.userInfo?.publicId,
    };
    let currentUser = JSON.parse(localStorage.getItem("_gmp"));
    localStorage.setItem(
      "_gmp",
      JSON.stringify({ ...currentUser, ...userObj })
    );

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateUserKYC = (id, data) => async (dispatch) => {
  try {
    const res = await UserService.updateKYC(id, data);
    dispatch({
      type: UPDATE_USER_STATUS,
      payload: res.data?.listUsers?.rows,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const deleteUser = (id, data) => async (dispatch) => {
  try {
    const res = await UserService.deleteUser(id, data);

    dispatch({
      type: DELETE_USER,
      payload: res.data?.listUsers?.rows,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const restoreUser = (id, data) => async (dispatch) => {
  try {
    const res = await UserService.restore(id, data);

    dispatch({
      type: RESTORE_USER,
      payload: res.data?.listUsers?.rows,
    });

    // return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
    // console.log(err)
  }
};

export const AddUserSuperAdmin = (data) => async (dispatch) => {
  try {
    const res = await UserService.addusersuperadmin(data);

    dispatch({
      type: ADD_USER_SUPERADMIN,
      payload: res.data.userInfo,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const onlineUsers = (data) => async (dispatch) => {
  try {
    dispatch({
      type: ONLINEUSERS,
      payload: data,
    });

    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const onlineUsersObj = (data) => async (dispatch) => {
  try {
    dispatch({
      type: ONLINEUSERSOBJ,
      payload: data,
    });

    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
export const noOnlineUsersObj = (data) => async (dispatch) => {
  try {
    dispatch({
      type: NOONLINEUSERSOBJ,
    });

    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const retrieveKycList = (param) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_KYC_LIST });
    const res = await UserService.getUnverifiedList(param);
    dispatch({
      type: FETCH_KYC_LIST_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: FETCH_KYC_LIST_FAILURE,
    });
    console.log(err);
  }
};

export const retrieveUserKycDetails = (param) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_USER_KYC_DETAILS });
    const res = await UserService.getUnverifiedUserDetails(param);
    dispatch({
      type: FETCH_USER_KYC_DETAILS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_KYC_DETAILS_FAILURE,
    });
    console.log(err);
  }
};

export const updateModule = (data) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_MODULE,
      payload: data,
    });
    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
